module.exports = __webpack_public_path__ + "media/public/images/about/services/01-e184d02072f950af88e7cbd005ccacf3.jpg";